import $ from "jquery";
import { initTinymce } from "./main";
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "forumDetail")
        return;
    init();
});
function init() {
    initTinymce('Answer', 300);
}
//# sourceMappingURL=forumDetail.js.map